import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NavBar from "../../Components/NavBar/NavBar";
import useAuth from '../../Components/Hooks/UseAuth';
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { fab,faExternalLinkAlt,faFileUpload, faTwitter,faInstagram,faYoutube, faLinkedin, faArrowDown, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'

import './EmployeeView.css';
import AttachmentsModal from '../../Components/AttachmentsModal/AttachmentsModal';
import { axiosPrivate } from '../../Components/api/Axios';
import axios from 'axios';
import PropagateLoader  from "react-spinners/HashLoader";
import BeatLoader from "react-spinners/SyncLoader";
import Footer from '../../Components/Footer/Footer';
import Faqs from '../../Components/FAQs/FAQs';
function EmployeeView() {
    const { id } = useParams();
    const [employee, setEmployee] = useState(null);
    const [files, setFiles] = useState([]);
    const [leaveRequests, setLeaveRequests] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState()
    const [fileSec, setFileSec] = useState()
    const [selectedFileType, setSelectedFileType] = useState('passport');
    const [selectedFileTypeSec, setSelectedFileTypeSec] = useState('academic');
    const [LoadingSec, setLoadingSec] = useState(false);
    const [addFile, setAddFile] = useState(false);
    const [fileLoader,setfileLoader] = useState(false)

    const [Loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [Msg, setMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState(false);
    const [Application, setApplication] = useState();
    const [courses, setCourses] = useState();
    

    const {auth} = useAuth()

    console.log("auth",auth)




    useEffect(()=>{
        async function getCourses (){ 
             
           try{      
 
             const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Application', {
                // signal: controller.signal,
                params: {
    
                    Org: auth?.UserID
                    // org: 'value2',
                    // mgtLvl: 'value2',
                  }
            }
             
             )
 
         
 
               if(response && response?.status == 200){ 
 
                   console.log("Application",response.data)
                   setApplication(response?.data?.AppData);
                 //  console.log("Applications",response?.data?.AppData)
            //        setTXNData(response?.data?.fndData);

            //    CalculateFund(response?.data?.AppData,response?.data?.fndData)


                   
 
               } else{
                //  setCourses(coursesType)
                //  console.log("Error req Application")
               }
              
 
           }catch(e){
            //  setCourses(coursesType)
                //  console.log("courses",courses)
           }
              
        }
 
         getCourses()
          
 
     },[])

    const HandleApplyView = (e,item) =>{

        // console.log("in handle applicaitn view")
        // console.log("item here",item)
        e.preventDefault();
        
    }

    // if(courseSel?.item){
    //     HandleApplyView((courseSel?.item))
    
    // }


    async function handleSubmit(e) { 
        e.preventDefault(); 
        setLoadingSec(true);
        setSuccessMsg(false);
        setErrorMsg(false);
    
     
        try {
            // Wait for the file upload to complete
            await HandleUpload();
            setLoadingSec(false);
            setAddFile(false)
            setFileSec('')
            await fetchAttachments(auth?.UserID)
    
            // Wait for the file upload to complete
            //await HandleUploadSec();
    
            // Proceed with form submission after file upload
           
    
        } catch (error) {
            console.log(error);
            setLoadingSec(false);
            setMsg("File upload failed!");
            setErrorMsg(true);
        }
    }

   

   // const [mockEmployeeData, setMockEmployeeData] = useState([]);

   const HandleFile = (e) => {
      
    const selectedFile = e.target.files[0];
    if (selectedFile?.size > 5242880) { // 5MB in bytes
        alert("File size should be less than 5MB");
        return;
    }else{
        setFileSec(selectedFile);
    }
   
  }


  const HandleUpload = () => {
    return new Promise((resolve, reject) => {
        // Check if a file is selected
        if (!fileSec) {
            window.alert("Kindly attach the required files");
            reject("No file selected for upload.");
            return; // Exit the function early if no file is present
        }

        const formdata = new FormData();
        formdata.append('image', fileSec);
        formdata.append('fileType', selectedFileType);

        // Append the UserID to the URL directly
        const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth?.UserID}`;

        axios.post(uploadURL, formdata)
            .then(res => {
                if (res.data.status === "Success") {
                    window.alert("Upload successful!");
                    resolve();
                } else {
                    window.alert("Upload failed!");
                    reject("Upload failed.");
                }
            })
            .catch(err => {
                window.alert("Error during upload!");
                console.log(err);
                reject(err);
            });
    });
};





const handleFileTypeChange = (e) => {
    setSelectedFileType(e.target.value);
}


    //async function getAllData() {
    //    const response = await fetch(`Employee/${id}`);
    //    const data = await response.json();
    //    setMockEmployeeData(data);
    //}

    // useEffect(() => {
        
        const fetchAttachments = async (userId) => {

            setfileLoader(true)
            try {
              const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
                params: { UserID: userId }
              });
              if (response) {
                // console.log('pulled', response);
                setSelectedFiles(response.data);
                setFiles(response.data);
                setIsModalOpen(true);
                setfileLoader(false)
              } else {
                // console.log('pull fail');
                setfileLoader(false)
              }
            } catch (e) {
                setfileLoader(false)
            //   console.log('catch error', e);
            }
          };
    
          
    //       fetchAttachments(auth?.UserID)


    // }, []);
    //useEffect(() => {
    //    getAllData();
    //}, []);


    // useEffect(() => {
    //     async function fetchEmployee() {
    //         try {
    //             const response = await fetch(`/employee/${id}`);
    //             console.log('Response:', response); // Log the response object

    //             // Check if the response is OK (status code 200-299)
    //             if (response.ok) {
    //                 const data = await response.json();
    //                 console.log('Employee data:', data); // Log the data
    //                 setEmployee(data);
    //             } else {
    //                 const errorText = await response.text();
    //                 console.error('Failed to fetch employee:', response.status, response.statusText, errorText);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching employee:', error);
    //         }
    //     }
    //     fetchEmployee();
    // }, [id]);



    useEffect(() => {

        console.log("Been called respective")
        async function fetchEmployee() {
            // Mock data for demonstration
            const mockEmployeeData = {
               id: id,
               fName: "John",
               lName: "Doe",
               email: "john.doe@example.com",
               phone: "123-456-7890",
               address: "123 Main St, Springfield",
               dob: "1980-01-01",
               doh: "2010-05-15",
               position: "Software Engineer",
               supervisor: "Jane Smith",
               currentPtoDays: 10,
               medical: "Yes",
               education: "Bachelor's Degree in Computer Science",
               department: "Engineering",
               picture: "/default-avatar.png", // Replace with actual image URL
               kinName: "Jane Doe",
               kinPhone: "987-654-3210"
            };


           // const response = await fetch(`Employee/${id}`);

           // console.log(response)
           //// const data = await response.json();

           // if (response) {
           //     console.log("in fetch respective")
           // }
            // setMockEmployeeData(response);

            //try {
            //    const response = await fetch(`/employee/${id}`);
            //    console.log('Response:', response); // Log the response object

            //    // Check if the response is OK (status code 200-299)
            //    if (response.ok) {
            //        const data = await response.json();
            //        console.log('Employee data:', data); // Log the data
            //        setMockEmployeeData(data);
            //    } else {
            //        const errorText = await response.text();
            //        console.error('Failed to fetch employee:', response.status, response.statusText, errorText);
            //    }
            //} catch (error) {
            //    console.error('Error fetching employee:', error);
            //}

            const mockFilesData = [
                { id: 1, name: "Resume", url: "/files/resume.pdf" },
                { id: 2, name: "Contract", url: "/files/contract.pdf" },
                // Add more files as needed
            ];

            const mockLeaveRequestsData = [
                { id: 1, startDate: "2024-07-15", endDate: "2024-07-18", status: "Pending", reason: "Vacation" },
                { id: 2, startDate: "2024-08-01", endDate: "2024-08-05", status: "Approved", reason: "Sick Leave" },
                // Add more leave requests as needed
            ];

            // Simulate a network request delay
            // setTimeout(() => {
            //   //  setEmployee(mockEmployeeData);
            //     setFiles(mockFilesData);
            //     setLeaveRequests(mockLeaveRequestsData);
            // }, 1000);
        }
        fetchEmployee();
    }, [id]);

    // if (!employee) {
    //     return <div>Loading...</div>;
    // }
    if (!auth) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <NavBar />
            <div className="employee-view-container">
                <div className="employee-card">
                    {/* <img src={employee?.picture || '/default-avatar.png'} alt={`${employee?.fName} ${employee?.lName}`} className="employee-image" /> */}
                    <div className="employee-details">
                        {/* <h2>{employee.fName} {employee.lName}</h2> */}
                        <p><strong>Name:</strong> {`${String(auth?.FName)} ${String(auth?.LName)} `}</p>
                        <p><strong>Passport/NRC:</strong> {String(auth?.NRC)}</p>
                        <p><strong>Phone:</strong> {auth?.phone}</p>
                        <p><strong>Email:</strong> {auth?.Email}</p>
                        {/* <p><strong>Address:</strong> {employee.address}</p>
                        <hr />
                        <h3>Next of Kin</h3>
                        <p><strong>Name:</strong> {`${employee.kinFName} ${employee.kinLName}`}</p>
                        <p><strong>Phone:</strong> {employee.kinPhone}</p>
                        <p><strong>Phone:</strong> {employee.kinPhone}</p>
                        <hr />
                        <p><strong>Date of Birth:</strong> {employee.dob}</p>
                        <p><strong>Date of Hire:</strong> {employee.doh}</p>
                        <p><strong>Position:</strong> {employee.position}</p>
                        <p><strong>Supervisor:</strong> {employee.supervisor}</p>
                        <p><strong>Current PTO Days:</strong> {employee.currentPtoDays}</p>
                        <p><strong>Medical:</strong> {employee.medical}</p>
                        <p><strong>Education:</strong> {employee.education}</p>
                        <p><strong>Relationship:</strong> {employee.kinRelationship}</p>
                        <hr /> */}
                        <h3>Files</h3>
                        <div className='clickableattachments'>
                            
                            
                            {fileLoader?
                            <>Loading files<PropagateLoader size={15} /> </>  :
                            
                           <p onClick={()=>fetchAttachments(auth?.UserID)}>View files <FontAwesomeIcon icon={faExternalLinkAlt}/></p>}
                        </div>
                        <div className='clickableattachments'>
                           <p onClick={()=>{
                              setAddFile(!addFile)
                           }}>Add file <FontAwesomeIcon icon={faFileUpload}/></p>
                        </div>
                        {addFile && <>

                                     <div className='applicationInputCover'> 
                                                <div className='applicationInputCover'>

                                                            <div className='applicationInputTitle'>
                                                                <h3>Attach File</h3>
                                                            </div>
                                                            <div className='applicationInputActual'>
                                                                <input  disabled={LoadingSec} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={HandleFile} />
                                                                <select id="fileType" defaultValue={selectedFileType} onChange={handleFileTypeChange} className="customdropdown">
                                                                    <option value="passport">NRC/Passport</option>
                                                                    <option value="academic">Academic Document</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                 
                                              </div>

                                              {LoadingSec?  

                                                <div className='beatloaderClass'> 
                                                <PropagateLoader size={30} />
                                                </div> :

                                                        <div className='resSechalf'>    
                                                        <div className='resAppword'></div>

                                                        <div className='resAppCTA'>
                                                            <button onClick={(e) => {
                                                            
                                                                handleSubmit(e)
                                                            }}>
                                                                {`Submit File`}
                                                            </button>
                                                        </div> 
                                                        </div>

                                                // <div onClick={handleSubmit} className='ApplicationCTA'> 
                                                // <  button>APPLY</button>

                                                // </div>

                                                }

                                             
                        
                             </>
                        
                        }
                       
                       
                          <AttachmentsModal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                files={selectedFiles}
                            />
                        {/* <ul>
                            {files.map(file => (
                                <li key={file.id}><a href={file.url} target="_blank" rel="noopener noreferrer">{file?.filename}</a></li>
                            ))}
                        </ul> */}
                        <hr />
                        <h3>Courses</h3>
                        <table className="leave-requests-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Status</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {Application?.map((item,index) => (
                                    <tr key={index+1}>
                                        <td>{item?.CourseName}</td>
                                        <td>{item.StartDate}</td>
                                        <td>{item?.EndDate}</td>
                                        <td>{item?.Status}</td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Faqs/>
            <Footer/>
        </div>
    );
}

export default EmployeeView;
